/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { ChangeEvent, FC, Fragment } from 'react';
import { ECollapsedNotes, OpenNoteProps, TwoOpenNoteProps } from '../../types';
import { Column } from '../../../../atoms/layoutPrimitives';
import { OpenNote } from '../open-note';
import { fullWidthCss } from '../../../../styles/utils';

export const TwoOpenNotes: FC<TwoOpenNoteProps> = ({
	isPublicFirst,
	publicValue,
	privateValue,
	labels,
	onChange,
	onCancel,
}) => {
	const handlePublicOnChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
		onChange(e, ECollapsedNotes.PUBLIC);
	};

	const handlePrivateOnChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
		onChange(e, ECollapsedNotes.PRIVATE);
	};

	const publicNoteProps = {
		openNote: labels.public,
		onChange: handlePublicOnChange,
		value: publicValue,
		labels: {
			tooltip: labels.publicTooltip,
			clear: labels.clear,
		},
		onCancel: () => onCancel(true),
		isCancelDisabled: !Boolean(publicValue),
	};

	const privateNoteProps = {
		openNote: labels.private,
		onChange: handlePrivateOnChange,
		value: privateValue,
		labels: {
			tooltip: labels.privateTooltip,
			clear: labels.clear,
		},
		onCancel: () => onCancel(false),
		isCancelDisabled: !Boolean(privateValue),
	};

	const props: OpenNoteProps[] = isPublicFirst
		? [publicNoteProps, privateNoteProps]
		: [privateNoteProps, publicNoteProps];

	return (
		<Column gap="0.5rem" fullWidth>
			{props.map((noteProps, index) => (
				<Fragment key={index}>
					<div css={[fullWidthCss, index > 0 && { marginTop: '1rem' }]}>
						<OpenNote {...noteProps} />
					</div>
				</Fragment>
			))}
		</Column>
	);
};
